import React from 'react';
import {FormInput} from '@homeaway/react-form-components';
import {RadioButton, RadioGroup} from '@homeaway/react-form-components';
import {
    getSelectOptions
} from '../utils/addressUtil';
import FormSelect from '@homeaway/react-form-select';
import {processTranslation, getTaxIdentifierQuestion, getTaxIdentifierLabel} from './commonUtil';
import {isNetNewIPM, isValidTaxIdentifierCountry} from '../../utils/validate';
import {InlineMessage} from '@homeaway/react-alerts';
import {COMPANY_REGISTRATION_NUMBER_MAX_LENGTH} from '../../utils/constants';

const VatChoice = (props) => {
    const {translations, vatChoice, handleVatChoiceChange, companyName} = props;
    const vatKey = translations['ipmob.vat_page.vat_key'];
    const vatChoiceHead = processTranslation(translations['ipmob.company_location.sub_heading_3'], [companyName, vatKey]);

    return (<div>
        <div className="wrapper">
            <div className="content-col-text sub-head">
                <h3>{vatChoiceHead}</h3>
            </div>
        </div>
        <div className="wrapper">
            <div className="content-col">
                <RadioGroup name="vatChoice" ariaLabel="VAT number choices for the yes, no">
                    <RadioButton
                        id="vatChoiceYes"
                        label={translations['ipmob.company_location.radio_button.text_1']}
                        value='Yes'
                        checked={(vatChoice === 'Yes')}
                        onChange={handleVatChoiceChange}
                        size="sm"
                    />
                    <RadioButton
                        id="vatChoiceNo"
                        label={translations['ipmob.company_location.radio_button.text_2']}
                        value='No'
                        checked={(vatChoice === 'No')}
                        onChange={handleVatChoiceChange}
                        size="sm"
                    />
                </RadioGroup>
            </div>
        </div>
    </div>);
};

const RegistrationNumber = (props) => {
    const {
        translations,
        registrationNumberChoice,
        handleRegistrationNumberChoiceChange,
        companyName,
        companyCountryCode,
        registrationNumber,
        registrationNumberError,
        handleRegistrationNumberChange,
        handleRegistrationNumberOnBlur,
        triggerEdapEventOnFocus,
        vatCountryCode,
        editFormOnchangeHandler,
        vatCountryCodeError,
        editFormOnBlurHandler,
        countryList,
        userType
    } = props;
    const registrationNumberHead = isValidTaxIdentifierCountry(companyCountryCode) ? translations[getTaxIdentifierQuestion(companyCountryCode)] : processTranslation(translations['ipmob.company_location.sub_heading_6'], [companyName]);
    const taxIdentifierLabel = isValidTaxIdentifierCountry(companyCountryCode) ? translations[getTaxIdentifierLabel(companyCountryCode)] : translations['ipmob.company_location.label_2'];
    const countryOptions = getSelectOptions(countryList);
    const noteLabel = translations['ipmob.company_location.note_label'];

    return (<div>
        <div className="wrapper">
            <div className="content-col-text sub-head">
                <h3>{registrationNumberHead}</h3>
            </div>
        </div>
        <div className="wrapper">
            <div className="content-col">
                <RadioGroup name="RegistrationNumberChoice" ariaLabel="Registration number choices for the yes, no">
                    <RadioButton
                        id="registrationNumberYes"
                        label={translations['ipmob.company_location.radio_button.text_1']}
                        value={translations['ipmob.company_location.radio_button.text_1']}
                        checked={(registrationNumberChoice === 'Yes')}
                        onChange={handleRegistrationNumberChoiceChange}
                        size="sm"
                    />
                    <RadioButton
                        id="registrationNumberNo"
                        label={translations['ipmob.company_location.radio_button.text_2']}
                        value={translations['ipmob.company_location.radio_button.text_2']}
                        checked={(registrationNumberChoice === 'No')}
                        onChange={handleRegistrationNumberChoiceChange}
                        size="sm"
                    />
                </RadioGroup>
            </div>
        </div>
        {(registrationNumberChoice === 'Yes')
            ? <div>
                {isNetNewIPM(userType) ?
                    <div>
                        {(companyCountryCode === 'GB')?
                        <div className="wrapper">
                            <div className="content-col-text">
                                <text>{noteLabel}</text>
                            </div>
                        </div>
                            :null
                        }
                        <div className="wrapper">
                            <div className="content-col">
                                <FormInput
                                    id="registrationNumber"
                                    type="text"
                                    name="Registration number"
                                    label={taxIdentifierLabel}
                                    value={registrationNumber}
                                    errorMsg={translations[registrationNumberError]}
                                    onChange={handleRegistrationNumberChange}
                                    maxLength={COMPANY_REGISTRATION_NUMBER_MAX_LENGTH}
                                    onBlur={handleRegistrationNumberOnBlur}
                                    onFocus={triggerEdapEventOnFocus}
                                />
                                <InlineMessage
                                    id="crnInfoMessage"
                                    type="info"
                                    message={translations['ipmob.company_location.crn_alphanumeric_only']}
                                    marginTop={-8}
                                    marginBottom={0}
                                />
                            </div>
                        </div>
                      </div>
                        :
                        <div>
                            {(companyCountryCode === 'GB')?
                                <div className="wrapper">
                                    <div className="content-col">
                                        <text>{noteLabel}</text>
                                    </div>
                                </div>
                                :null
                            }
                            <div className="wrapper">
                                <div className="content-col">
                                    <FormSelect
                                        id="vatCountry"
                                        name="Country selected - VAT"
                                        items={countryOptions}
                                        label={translations['ipmob.address.label_1']}
                                        value={vatCountryCode}
                                        onChange={editFormOnchangeHandler}
                                        errorMsg={translations[vatCountryCodeError]}
                                        onBlur={editFormOnBlurHandler}
                                    />
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col">
                                    <FormInput
                                        id="registrationNumber"
                                        type="text"
                                        name="Registration number"
                                        label={taxIdentifierLabel}
                                        value={registrationNumber}
                                        errorMsg={translations[registrationNumberError]}
                                        onChange={handleRegistrationNumberChange}
                                        maxLength={COMPANY_REGISTRATION_NUMBER_MAX_LENGTH}
                                        onBlur={handleRegistrationNumberOnBlur}
                                        onFocus={triggerEdapEventOnFocus}
                                    />
                                    <InlineMessage
                                        id="crnInfoMessage"
                                        type="info"
                                        message={translations['ipmob.company_location.crn_alphanumeric_only']}
                                        marginTop={-8}
                                        marginBottom={0}
                                    />
                                </div>
                            </div>
                    </div>
                }
            </div>
            : null
        }
    </div>);
};

export {
    VatChoice,
    RegistrationNumber
};
